/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { override, extend } from 'flarum/common/extend';
import ReviewComposer from '../components/ReviewComposer';
// @ts-expect-error fof/drafts ships no typings (remove this once it does)
import * as drafts from '@fof-drafts';

// fof/drafts ships no typings, so `override()` widens its method parameters to `unknown`. Named
// locally rather than re-declaring the foreign class.
type Draft = any;

export default function () {
	if (app.initializers.has('fof-drafts')) {
		const DraftsListState = drafts.states.DraftsListState;
		const Draft = drafts.models.Draft;

		// CODE_OVERRIDE
		override(DraftsListState.prototype, 'showComposer', function (original, draft: Draft) {
			if (draft.type() !== 'review') {
				return original(draft);
			} else {
				if (this.loading) return;

				return new Promise((resolve) => {
					const data = draft.compileData();
					// `autobind` widens the export to `void | typeof ReviewComposer`.
					app.composer.load(ReviewComposer as Exclude<typeof ReviewComposer, void>, data);
					app.composer.show();

					// `load()` above always populates `fields`, which core types as optional.
					Object.assign(app.composer.fields!, data.fields);

					return resolve(app.composer);
				});
			}
		});

		// CODE_OVERRIDE
		override(Draft.prototype, 'type', function (original) {
			if (this.extra() && this.extra().review) {
				return 'review';
			}
			return original();
		});
		// CODE_OVERRIDE
		override(Draft.prototype, 'icon', function (original) {
			if (this.type() === 'review') {
				return 'far fa-book-heart';
			}
			return original();
		});

		extend(Draft.prototype, 'compileData', function (data) {
			if (this.type() === 'review') {
				const articleData = {
					type: 'of_articles',
					attributes: {
						id: this.extra().review.articleID,
						ean: this.extra().review.articleEAN,
						title: this.extra().review.articleTitle,
					},
				};

				data.article = app.store.createRecord(articleData.type, articleData);
				data.rating = this.extra().review.rating;
			}
		});
	}
}
